<template>
  <v-tooltip bottom style="position: absolute" :disabled="!errorStatus && !notCreated && !warningStatus">
    <template #activator="{ on }">
      <tr :class="{'warning-response': warningStatus, 'error-response': errorStatus}" v-on="on">
        <td v-if="checkboxConditions">
          <v-checkbox
            v-model="selected"
            style="padding-top: 15px"
            color="accent"
            @change="selectItem"
          />
        </td>
        <td v-else />
        <td>{{ item.created_at }}</td>
        <td>{{ item.user_id }}</td>
        <td>
          <v-btn
            text
            small
            flat
            :to="{ name: 'user', params: { user: item.user.id } }"
            style=" text-transform: none; padding: 0;"
          >
            {{ item.user.name }}
          </v-btn>
        </td>
        <td>{{ item.user.verification_status | verificationStatus }}</td>
        <td>{{ item.method }}</td>
        <td>{{ item.payway }}</td>
        <td>{{ item.bank_name }}</td>
        <td>{{ item.bill }}</td>
        <td v-if="isExnode" class="cryptomus-amount">
          <span class="crypt-amount" :title="item.crypto_amount">{{ item.crypto_amount }}</span>
          <span class="rub-amount">{{ item.amount }}</span>
        </td>
        <td v-else>{{ item.amount }}</td>
        <td>
          {{ shortWord(item.payment_transaction_id) }}
          <v-icon
            v-if="item.payment_transaction_id"
            style="cursor: pointer"
            small
            @click="copyID(item.payment_transaction_id)"
          >
            content_copy
          </v-icon>
        </td>

        <td>
          {{ shortWord(item.outer_transaction_id) }}
          <v-icon
            v-if="item.outer_transaction_id"
            style="cursor: pointer"
            small
            @click="copyID(item.outer_transaction_id)"
          >
            content_copy
          </v-icon>
        </td>
        <td>{{ item.statusString }}</td>
        <td>
          <template v-if="item.admin !== null">{{ item.admin.name }}</template>
        </td>
        <td>
          <div :class="`payouts-color-${item.user.wager}`" />
        </td>
        <td>
          <div :class="`trust-color-${item.trust_point?.status}`" />
        </td>
        <td class="icon-td">
          <template v-if="item.status === 0">
            <v-icon
              v-if="isExnode || isCards || isBankCheck || isOtherFiat"
              class="icon"
              small
              @click="selectModal"
            >
              currency_exchange
            </v-icon>
            <v-icon class="icon" small @click="confirm(2)">fas fa-check</v-icon>
            <v-icon class="icon" small @click="confirm(1)">fas fa-times</v-icon>
            <v-icon class="icon" small @click="confirmMultiAcc">fas fa-question</v-icon>
          </template>
        </td>

        <PayoutsMethodsModal
          :snackbar="snackbar"
          :is-disabled="isDisabled"
          :snackbar-text="snackbarText"
          :confirmation-dialog="confirmationDialog"
          :payment-dialog="paymentDialog"
          @update:snackbar="(val) => {snackbar = val}"
          @update:confirmationDialog="(val) => {confirmationDialog = val}"
          @update:paymentDialog="(val) => {paymentDialog = val}"
          @selectedMethod="selectedMethod"
          @selectPayment="confirmPayment"
          @clear="clear"
        />
      </tr>
    </template>

    <span v-if="errorStatus || notCreated || warningStatus">
      {{ item.error_message ?? 'Проверьте транзакцию в платежной системе. Транзакция не создалась.' }}
    </span>
  </v-tooltip>
</template>

<script>
import { updateStatus } from '../../../../../api/transactions'
import { confirmMultiAcc } from '../../../../../api/user'
import PayoutsMethodsModal from '@/components/modals/PayoutsMethodsModal.vue'

export default {
  name: 'PaymentItem',
  components: { PayoutsMethodsModal },
  filters: {
    verificationStatus (value) {
      return value ? 'Да' : 'Нет'
    }
  },
  props: {
    item: Object,
    changeSelect: Boolean,
    paymentMethod: String | null
  },
  data () {
    return {
      SELECTED_ITEM_STATUS: {
        0: 'В обработке',
        1: 'Отказано',
        2: 'Принято',
        4: 'Запрос отправлен'
      },
      selected: false,
      paymentDialog: false,
      confirmationDialog: false,
      isCryptomus: false,
      paymentSystem: null,
      isDisabled: false,
      snackbar: false,
      snackbarText: null
    }
  },
  computed: {
    isCards () {
      return this.item.method === 'cards' || (this.item.method === 'sbp' && this.item.amount >= 500)
    },
    isExnode () {
      if (this.item.payway)
        return (this.item.payway.startsWith('exnode'))
    },
    isBankCheck () {
      return (this.item.method === 'bank_account_number')
    },
    isOtherFiat () {
      return ['piastrix', 'freekassa', 'fk_wallet'].includes(this.item.method)
    },
    checkboxConditions () {
      return this.item.status === 0
          && (this.paymentMethod === null
          || (!['cards', 'sbp', 'bank_account_number', 'piastrix', 'freekassa', 'fk_wallet']
            .includes(this.paymentMethod)
            && this.isExnode)
              || this.paymentMethod === this.item.method)
          && (this.isCards || this.isBankCheck || this.isOtherFiat || this.isExnode)
    },
    warningStatus () {
      return this.item.withdrawal_request_status === 4 && (this.item.status === 0 || this.item.status === 9)
    },
    errorStatus () {
      return this.item.withdrawal_request_status === 3 && (this.item.status === 0 || this.item.status === 9)
    },
    notCreated () {
      return this.item.withdrawal_request_status === 5 && (this.item.status === 0 || this.item.status === 9)
    }
  },
  watch: {
    changeSelect (newValue) {
      if (newValue === true) this.selected = false
    }
  },
  methods: {
    selectedMethod (method) {
      this.paymentSystem = method
      this.paymentDialog = false
      this.confirmationDialog = true
    },
    selectModal () {
      if (this.isExnode) {
        this.isCryptomus = true
        this.confirmationDialog = true
        this.paymentSystem = 'exnode'
      } else if (this.isOtherFiat) {
        this.item.method === 'piastrix' ? this.paymentSystem = 'piastrix' : this.paymentSystem = 'fk_wallet'
        this.confirmationDialog = true
      } else {
        this.paymentDialog = true
      }
    },
    clear () {
      this.confirmationDialog = false
      this.isCryptomus = false
      this.paymentSystem = null
      this.isDisabled = false
    },
    selectItem () {
      this.$emit('item-selected', { item: this.item, selected: this.selected })
    },
    async confirmPayment () {
      this.isDisabled = true
      try {
        const res = await updateStatus({
          payment_system: this.paymentSystem,
          transaction_ids: [this.item.id]
        })
        const hasError = res.data.some(item => item.error_message)
        if (hasError) {
          this.snackbarText = 'Ошибка'
          this.snackbar = true
          return
        }

        this.snackbarText = 'Успешно'
        this.item.status = res.data.status
        this.item.statusString = this.SELECTED_ITEM_STATUS[this.item.status]
      } catch (err) {
        this.snackbarText = `Ошибка: ${err.response?.status} ${err.response?.data.message || err.message}`
      } finally {
        this.snackbar = true
        this.clear()
        this.$emit('refresh-table')
        this.$emit('clear')
      }
    },
    confirmMultiAcc () {
      confirmMultiAcc(this.item.user_id)
        .then(response => {
          alert(`Пользователей с таким ip: ${response.data.count}`)
        })
    },
    shortWord (item) {
      if (item)
        return item.length > 10 ? `${item.slice(0, 10)}...` : item
    },
    copyID (id) {
      navigator.clipboard.writeText(id)
        .then(() => {
          this.$emit('copied')
        })
    },
    confirm (status) {
      updateStatus({
        status,
        transaction_ids: [this.item.id]
      }).then(response => {
        if (response.error_message) {
          this.snackbarText = response.error_message
          this.snackbar = true
          return
        }

        this.item.status = response.data.status
        this.item.statusString = this.SELECTED_ITEM_STATUS[this.item.status]
        this.$emit('refresh-table')
      })
    }
  }
}
</script>

<style scoped>
.payouts-color-0, .payouts-color-1, .payouts-color-2 {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.payouts-color-0 {
  background: red;
}

.payouts-color-1 {
  background: yellow;
}

.payouts-color-2 {
  background: green;
}

.trust-color-1, .trust-color-2, .trust-color-0 {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.trust-color-1 {
  background: red;
}

.trust-color-2 {
  background: green;
}

.trust-color-0 {
  background: yellow;

}

.cryptomus-amount .crypt-amount{
  display:inline-block;
  max-width:12ch;
  overflow: hidden;
  text-overflow: ellipsis;
  font:inherit;
}
.cryptomus-amount .rub-amount{
  font:inherit;
  margin-left: 0;
}
.cryptomus-amount .rub-amount::before{
  content: ' (';
  user-select: none;
  font:inherit;
}
.cryptomus-amount .rub-amount::after{
  content: ')';
  user-select: none;
  font:inherit;
}
.cryptomus-amount{
  display:flex;
}

.icon-td {
  text-align: center;
  display:flex;
  justify-content: flex-end;
  align-items:center;
  gap: 20px;
}

.icon-td .icon {
  cursor: pointer;
  font-size: 18px !important;
}

.warning-response {
  box-shadow: inset 0 0 0 2px #FFD700 !important;
}

.error-response {
  box-shadow: inset 0 0 0 2px red !important;
}
</style>
